module.exports = __webpack_public_path__ + "static/assets/dae93806fd78b5f77d281cd92bd33ffe.png";